import React from 'react'

function TermsAndCondition() {
  return (
    
    <div className="privacy-policy">
    <div className="privacy-policy-in">
 
    <h1>Terms and Conditions</h1>
    <p>Welcome to CGTHomes! By accessing our website, you agree to comply with the following terms and conditions.</p>
    
    <h2>1. Use of Website</h2>
    <p>This website is intended for informational and commercial purposes. Any unauthorized use may result in legal action.</p>
    
    <h2>2. Intellectual Property</h2>
    <p>All content, trademarks, and intellectual property on this website belong to CGTHomes and cannot be used without permission.</p>
    
    <h2>3. User Conduct</h2>
    <p>You agree not to engage in any activity that may harm the website or other users.</p>
    
    <h2>4. Liability Limitation</h2>
    <p>We are not responsible for any damages or losses resulting from the use of this website.</p>
    
    <h2>5. Changes to Terms</h2>
    <p>We reserve the right to modify these terms at any time. Continued use of the website constitutes acceptance of the revised terms.</p>
    
    <h2>6. Contact Us</h2>
    <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
    <p>Name: CGTHomes </p>
    <p>Email: info@cgthomes.com</p>
    <p>Company Email: support@cgthomes.com</p>
    <p>Company Address: Street No 3, DLF Cyber City Hyderabad, telengana</p>

    </div>
  </div>
  )
}

export default TermsAndCondition